import React, { FC } from 'react';
import { HeadFC, PageProps, graphql } from 'gatsby';

import SEO from '../../components/Head';
import { DEFAULT_LOCALE } from '../../i18n';

import LayoutRaw from '../../components/Layout/Layout';
import PageContent from './PageContent';

interface ContextType {
  locale: string;
  crypto: string;
}

const Template: FC<PageProps<Queries.SeoPageQuery, ContextType>> = props => {
  const { data, pageContext } = props;
  return (
    <LayoutRaw>
      <PageContent
        data={data}
        locale={pageContext.locale}
        crypto={pageContext.crypto}
      />
    </LayoutRaw>
  );
};

export const Head: HeadFC<Queries.SeoPageQuery, ContextType> = ({
  data: { json },
  pageContext,
  location,
}) => {
  let canonicalPath = location.pathname;

  if (pageContext.crypto === 'btc') {
    canonicalPath =
      pageContext.locale === DEFAULT_LOCALE ? '/' : `/${pageContext.locale}/`;
  }

  return (
    <SEO
      meta={json?.meta || null}
      pathname={canonicalPath}
      locale={pageContext.locale}
    />
  );
};

export const query = graphql`
  query SeoPage($id: String!) {
    json(id: { eq: $id }) {
      ...Meta
      ...SeoNavbar
      ...SeoHeaderHome
      ...SeoWhyHome
      ...SeoGuideHome
      ...SeoFaq
      ...SeoBitcoinPriceSection
      ...SeoReadytoGetStarted
      ...SeoFooter
    }
  }
`;

export default Template;
